import { render, staticRenderFns } from "./TimelineQuizDetail.vue?vue&type=template&id=98e1dae0&"
import script from "./TimelineQuizDetail.vue?vue&type=script&lang=js&"
export * from "./TimelineQuizDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports